import { History } from 'lucide-react';
import { Container, PageHeader, Section } from '@vnetwork/ui/layout';
import { Card, CardBody, Badge } from '@vnetwork/ui/primitives';
import { CHANGELOG, type ChangeType } from './changelog-data';
import { brand } from '@/config/brand';
import styles from './Changelog.module.css';

const TYPE_META: Record<ChangeType, { tone: 'success' | 'info' | 'warning'; label: string }> = {
  feature: { tone: 'success', label: 'New' },
  improvement: { tone: 'info', label: 'Improved' },
  fix: { tone: 'warning', label: 'Fixed' },
};

/** Product changelog — release notes for the console (legacy Changelog page). */
export default function ChangelogPage() {
  const current = CHANGELOG[0]?.version;
  return (
    <Container size="lg">
      <PageHeader
        icon={<History size={22} />}
        eyebrow="Product"
        title="Changelog"
        description={`All notable changes to the ${brand.shortName} console.`}
        actions={
          current ? (
            <Badge tone="primary" appearance="subtle">
              v{current}
            </Badge>
          ) : undefined
        }
      />

      <div className={styles.timeline}>
        {CHANGELOG.map((release) => (
          <Section key={release.version} title={`v${release.version}`} description={release.date} style={{ marginBottom: 0 }}>
            <Card flat>
              <CardBody>
                <ul className={styles.list}>
                  {release.changes.map((change, i) => {
                    const meta = TYPE_META[change.type];
                    return (
                      <li key={i} className={styles.item}>
                        <Badge tone={meta.tone} appearance="subtle" size="sm">
                          {meta.label}
                        </Badge>
                        <span>{change.text}</span>
                      </li>
                    );
                  })}
                </ul>
              </CardBody>
            </Card>
          </Section>
        ))}
      </div>

      <p className={styles.note}>This changelog is generated from conventional commits.</p>
    </Container>
  );
}
